import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'medical-order-scann-component',
  templateUrl: './medical-order-scann.component.html',
  styleUrls: ['./medical-order-scann.component.css']
})
export class MedicalOrderScannComponent {
  medicalorderId: number;
  constructor(private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      this.medicalorderId = params['MedicalOrderId'];
    });
  }

  finish(): void {
    history.back();
  }
}
